import { FC, useState } from 'react'
import Task, { DrawStampTaskDetails } from '../../../types/api/task'
import { Alert, Button, Checkbox, Form, Modal, notification } from 'antd'
import { useForm } from 'antd/es/form/Form'
import useUploadFiles from '../../../hooks/api/use-upload-file'
import UploadFile from '../../../components/form-items/upload-file/upload-file'
import { UploadFile as UploadFileInterface } from 'antd/es/upload'
import { useUpdateStampMutation } from '../../../store/api/stamps-api'
import { StrapiUpdate } from '../../../types/strapi/strapi'
import { useUpdateTaskMutation } from '../../../store/api/tasks-api'
import useErrorModal from '../../../hooks/api/use-error-modal'
import dayjs from 'dayjs'

interface CopmleteDrawingStampProps {
    task: Task
}

const CopmleteDrawingStamp: FC<CopmleteDrawingStampProps> = ({ task }) => {
    const [form] = useForm()
    const [open, setOpen] = useState<boolean>(false)
    const [uploadFiles, uploadState] = useUploadFiles()
    const [updateStamp, updateStampState] = useUpdateStampMutation()
    const [updateTask, updateTaskState] = useUpdateTaskMutation()

    useErrorModal(updateStampState, 'Не удалось обновить штамп')
    useErrorModal(updateTaskState, 'Не удалось обновить задачу')

    const onClick = () => {
        setOpen(true)
    }

    const getUpdateTaskQueryArg = (urgent: boolean, stampId: string): StrapiUpdate<Task> => ({
        docId: task.documentId,
        body: {
            data: {
                taskStatus: 'Завершена',
                endDate: dayjs().toISOString(),
                details: {
                    type: 'Отрисовка штампа',
                    stampId,
                    urgent,
                },
            },
        },
    })

    const onOk = async () => {
        try {
            await form.validateFields()
            // const files: UploadFileInterface<any>[] = form.getFieldValue('files') ?? []
            const stampDocId = (task.details as DrawStampTaskDetails).stampId

            // if (!stampDocId) {
            //     Modal.error({ content: 'Детали задачи не содержат идентификатора штампа' })
            //     return
            // }

            // const result = await uploadFiles(files)

            // if (!result.data?.length) {
            //     Modal.error({
            //         title: 'Не удалось сохранить файл',
            //         content: result.error ? JSON.stringify(result.error) : undefined,
            //     })
            //     return
            // }

            // await updateStamp({
            //     docId: stampDocId,
            //     body: {
            //         data: {
            //             image: result.data[0].id,
            //         },
            //     },
            // }).unwrap()

            const urgent = Boolean(form.getFieldValue('urgent'))
            await updateTask(getUpdateTaskQueryArg(urgent, stampDocId)).unwrap()

            notification.success({ message: 'Задача закрыта' })
            setOpen(false)
            form.resetFields()
        } catch (e) {
            if (e && typeof e === 'object' && 'errorFields' in e) {
                return
            }
            console.error(e)
            Modal.error({ content: 'Не удалось завершить задачу' })
        }
    }

    return (
        <>
            <Button type={'primary'} onClick={onClick} disabled={task.taskStatus === 'Завершена'}>
                Завершить
            </Button>

            <Modal
                title={'Задача отрисовки штампа'}
                open={open}
                okText={'Завершить задачу'}
                onOk={onOk}
                okButtonProps={{
                    loading:
                        uploadState.isLoading ||
                        updateStampState.isLoading ||
                        updateTaskState.isLoading,
                }}
                onCancel={() => {
                    setOpen(false)
                    form.resetFields()
                }}
                onClose={() => {
                    setOpen(false)
                    form.resetFields()
                }}
                destroyOnClose
                cancelButtonProps={{ danger: true }}
            >
                <Form form={form} layout={'vertical'} initialValues={{ urgent: false }}>
                    <Alert
                        message={'Пожалуйста, не забудьте загрузить макет штампа на сервер'}
                        type={'info'}
                    />
                    {/* TODO: пока пользуемся ссылками с гугл диска, загрузку в системе реализуем позже */}
                    {/* <UploadFile
                        name={'files'}
                        label={'Изображение штампа'}
                        rules={[{ required: true, message: 'Загрузите изображение штампа' }]}
                    /> */}
                    <br />
                    <Form.Item name={'urgent'} valuePropName={'checked'}>
                        <Checkbox>Срочный заказ</Checkbox>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default CopmleteDrawingStamp
